!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.egdistances = e() : t.egdistances = e();
}(this, function () {
  return function () {
    "use strict";

    var t = {
        d: function (e, n) {
          for (var r in n) t.o(n, r) && !t.o(e, r) && Object.defineProperty(e, r, {
            enumerable: !0,
            get: n[r]
          });
        },
        o: function (t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        },
        r: function (t) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(t, "__esModule", {
            value: !0
          });
        }
      },
      e = {};
    t.r(e), t.d(e, {
      EGDistances: function () {
        return nt;
      }
    });
    var n = {
        providers: {
          mapbox: "mapbox",
          google: "google",
          eg: "eg"
        },
        modes: {
          driving: "driving",
          walking: "walking",
          cycling: "cycling",
          transit: "transit"
        },
        units: {
          meter: "meter",
          kilometer: "kilometer",
          mile: "mile",
          foot: "foot",
          second: "second",
          minute: "minute",
          hour: "hour"
        },
        statuses: {
          success: "SUCCESS",
          failure: "FAILURE"
        }
      },
      r = {
        provider: n.providers.mapbox,
        providers: {
          mapbox: {
            key: "SET_ME",
            url: "https://api.mapbox.com",
            overview: "full"
          },
          google: {},
          eg: {
            key: "SET_ME",
            url: ""
          }
        }
      };
    var o = function t() {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t);
    };
    try {
      o.isEcmaIntlSupported = "1 m" === new Intl.NumberFormat("en-US", {
        style: "unit",
        unit: n.units.meter,
        unitDisplay: "short"
      }).format(1);
    } catch (t) {
      o.isEcmaIntlSupported = !1;
    }
    o.format = function (t, e, n) {
      if (t && void 0 !== e && n && o.isEcmaIntlSupported) try {
        return new Intl.NumberFormat(t, {
          style: "unit",
          unit: n,
          unitDisplay: "short"
        }).format(e);
      } catch (t) {}
    }, o.round = function (t, e) {
      switch (e) {
        case n.units.meter:
        case n.units.foot:
          switch (!0) {
            case Math.round(t) < 100:
              return Math.round(t);
            case Math.round(t) < 1e3:
              return 10 * Math.round(t / 10);
            default:
              return 100 * Math.round(t / 100);
          }
        case n.units.kilometer:
        case n.units.mile:
          switch (!0) {
            case 0 == Math.round(100 * t):
            case Math.round(100 * t) < 100:
              return Math.round(100 * t) / 100;
            case Math.round(t) > 100:
              return Math.round(t);
            default:
              return Math.round(10 * t) / 10;
          }
        case n.units.second:
          switch (!0) {
            case Math.round(t) < 30:
              return Math.round(t);
            default:
              return 10 * Math.round(t / 10);
          }
        case n.units.minute:
          switch (!0) {
            case Math.round(10 * t) < 10:
              return Math.round(10 * t) / 10;
            default:
              return Math.round(t);
          }
        case n.units.hour:
          return Math.round(10 * t) / 10;
        default:
          throw new Error("round for ".concat(e, " not implemented"));
      }
    }, o.convert = function (t, e) {
      var r = u(e),
        o = t.find(function (t) {
          return u(t.unit) === r;
        });
      if (o) {
        if (o.unit === e) return o.value;
        if (0 === r) {
          var c = a(o);
          switch (e) {
            case n.units.meter:
              return c;
            case n.units.kilometer:
              return c / 1e3;
            case n.units.mile:
              return c / 1609.344;
            case n.units.foot:
              return c / .3048;
          }
        } else if (1 === r) {
          var s = i(o);
          switch (e) {
            case n.units.second:
              return s;
            case n.units.minute:
              return s / 60;
            case n.units.hour:
              return s / 3600;
          }
        }
      }
    };
    var i = function (t) {
        switch (t.unit) {
          case n.units.second:
            return t.value;
          case n.units.minute:
            return 60 * t.value;
          case n.units.hour:
            return 3600 * t.value;
        }
      },
      a = function (t) {
        switch (t.unit) {
          case n.units.meter:
            return t.value;
          case n.units.kilometer:
            return 1e3 * t.value;
          case n.units.mile:
            return 1609.344 * t.value;
          case n.units.foot:
            return .3048 * t.value;
        }
      },
      u = function (t) {
        switch (t) {
          case n.units.meter:
          case n.units.kilometer:
          case n.units.mile:
          case n.units.foot:
            return 0;
          case n.units.second:
          case n.units.minute:
          case n.units.hour:
            return 1;
          default:
            throw new Error("Invalid distance unit ".concat(t));
        }
      };
    function c(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }
    function s(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    var f = function t(e, n) {
        s(this, t), this.value = e, this.unit = n;
      },
      l = function t(e, n, r, i) {
        s(this, t), this.origin = e, this.destination = n, this.modes = {}, r && (this.modes[r] = i, this.modes[r].as = function (t, e, n) {
          var r = o.convert(i, t);
          return e && (r = o.round(r, t)), n && o.format(n, r, t) || r;
        });
      },
      p = function () {
        function t(e, n) {
          s(this, t), this.matrix = e, this.errors = n || [];
        }
        var e, r, o;
        return e = t, (r = [{
          key: "status",
          get: function () {
            return this.errors && this.errors.length > 0 ? n.statuses.failure : n.statuses.success;
          }
        }]) && c(e.prototype, r), o && c(e, o), t;
      }();
    var d = function t(e, n, r, i) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t), this.origin = e, this.destination = n, this.mode = r, i && (this.distance = i, this.distance.as = function (t, e, n) {
        var r = o.convert(i, t);
        return e && (r = o.round(r, t)), n && o.format(n, r, t) || r;
      });
    };
    function y(t, e) {
      var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
      if (!n) {
        if (Array.isArray(t) || (n = function (t, e) {
          if (!t) return;
          if ("string" == typeof t) return m(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          "Object" === n && t.constructor && (n = t.constructor.name);
          if ("Map" === n || "Set" === n) return Array.from(t);
          if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return m(t, e);
        }(t)) || e && t && "number" == typeof t.length) {
          n && (t = n);
          var r = 0,
            o = function () {};
          return {
            s: o,
            n: function () {
              return r >= t.length ? {
                done: !0
              } : {
                done: !1,
                value: t[r++]
              };
            },
            e: function (t) {
              throw t;
            },
            f: o
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var i,
        a = !0,
        u = !1;
      return {
        s: function () {
          n = n.call(t);
        },
        n: function () {
          var t = n.next();
          return a = t.done, t;
        },
        e: function (t) {
          u = !0, i = t;
        },
        f: function () {
          try {
            a || null == n.return || n.return();
          } finally {
            if (u) throw i;
          }
        }
      };
    }
    function m(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
      return r;
    }
    function h(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }
    var v,
      g = Object.values(n.modes),
      b = function () {
        function t() {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t);
        }
        var e, r, o;
        return e = t, (r = [{
          key: "getDistances",
          value: function (t, e, r) {
            if (!t || !e) return Promise.reject(new Error("Missing origin/destination information: ".concat(t, " / ").concat(e)));
            var o = Array.isArray(t) ? t : [t],
              i = Array.isArray(e) ? e : [e],
              a = r ? Array.isArray(r) ? r : [r] : [n.modes.driving];
            return this._getDistances(this._validateAllLatLng(o), this._validateAllLatLng(i), this._validateModes(a));
          }
        }, {
          key: "_getDistances",
          value: function (t, e, n) {
            var r = this,
              o = n.map(function (n) {
                return r._computeDistancesForMode(t, e, n).then(function (t) {
                  return {
                    mode: n,
                    matrix: t
                  };
                }).catch(function (o) {
                  return {
                    mode: n,
                    matrix: r._emptyMatrix(t, e),
                    error: o
                  };
                });
              });
            return Promise.all(o).then(function (n) {
              var o = n.reduce(function (t, e) {
                  return t.map(function (t, n) {
                    return t.map(function (t, r) {
                      return t.modes[e.mode] = e.matrix[n][r] ? e.matrix[n][r].modes[e.mode] : void 0, t;
                    });
                  });
                }, r._emptyMatrix(t, e)),
                i = n.map(function (t) {
                  return t.error;
                }).filter(function (t) {
                  return !!t;
                });
              return new p(o, i);
            });
          }
        }, {
          key: "_computeDistancesForMode",
          value: function (t, e, n) {
            return Promise.reject(new Error("NOT IMPLEMENTED."));
          }
        }, {
          key: "_validateMode",
          value: function (t) {
            if (!g.includes(t)) throw new Error("Unknown mode ".concat(t, " - valid modes are ").concat(g));
            return t;
          }
        }, {
          key: "_validateModes",
          value: function (t) {
            var e,
              n = y(t);
            try {
              for (n.s(); !(e = n.n()).done;) {
                var r = e.value;
                this._validateMode(r);
              }
            } catch (t) {
              n.e(t);
            } finally {
              n.f();
            }
            return t;
          }
        }, {
          key: "_validateLatLng",
          value: function (t) {
            if (!t) throw new Error("no data for latLng");
            if (!t.lat) throw new Error("Missing lat information in ".concat(t));
            if (!t.lng) throw new Error("Missing lng information in ".concat(t));
            return t;
          }
        }, {
          key: "_validateAllLatLng",
          value: function (t) {
            var e,
              n = y(t);
            try {
              for (n.s(); !(e = n.n()).done;) {
                var r = e.value;
                this._validateLatLng(r);
              }
            } catch (t) {
              n.e(t);
            } finally {
              n.f();
            }
            return t;
          }
        }, {
          key: "_fetch",
          value: function (t, e) {
            return fetch(t, e);
          }
        }, {
          key: "_emptyMatrix",
          value: function (t, e) {
            return new Array(t.length).fill([]).map(function (n, r) {
              return new Array(e.length).fill(null).map(function (n, o) {
                return new l(t[r], e[o]);
              });
            });
          }
        }, {
          key: "getRoute",
          value: function (t, e) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : n.modes.driving;
            return this._computeRouteForMode(this._validateLatLng(t), this._validateLatLng(e), this._validateMode(r)).then(function (t) {
              return {
                status: n.statuses.success,
                route: t
              };
            }).catch(function (o) {
              return {
                status: n.statuses.failure,
                error: o,
                route: new d(t, e, r)
              };
            });
          }
        }, {
          key: "_computeRouteForMode",
          value: function (t, e, n) {
            return Promise.reject(new Error("NOT IMPLEMENTED."));
          }
        }]) && h(e.prototype, r), o && h(e, o), t;
      }();
    function w(t) {
      return (w = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }
    function M(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
        if (null == n) return;
        var r,
          o,
          i = [],
          a = !0,
          u = !1;
        try {
          for (n = n.call(t); !(a = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); a = !0);
        } catch (t) {
          u = !0, o = t;
        } finally {
          try {
            a || null == n.return || n.return();
          } finally {
            if (u) throw o;
          }
        }
        return i;
      }(t, e) || function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return O(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return O(t, e);
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function O(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
      return r;
    }
    function S(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }
    function E(t, e) {
      return (E = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }
    function j(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = k(t);
        if (e) {
          var o = k(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return _(this, n);
      };
    }
    function _(t, e) {
      if (e && ("object" === w(e) || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t);
    }
    function k(t) {
      return (k = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }
    function x(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }
    var P = (x(v = {}, n.modes.driving, "DRIVING"), x(v, n.modes.cycling, "BICYCLING"), x(v, n.modes.transit, "TRANSIT"), x(v, n.modes.walking, "WALKING"), v),
      A = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && E(t, e);
        }(a, t);
        var e,
          r,
          o,
          i = j(a);
        function a(t) {
          var e, n;
          if (function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, a), (n = i.call(this)).config = null === (e = t.providers) || void 0 === e ? void 0 : e.google, !google || !google.maps) throw new Error("Unable to find Google Maps - make sure Google API library is initialized.");
          if (!google.maps.DistanceMatrixService) throw new Error("Unable to load Google Maps DistanceMatrixService - make sure Google API library is initialized.");
          if (!google.maps.DirectionsService) throw new Error("Unable to load Google Maps DirectionsService - make sure Google API library is initialized.");
          return n.distanceMatrixService = new google.maps.DistanceMatrixService(), n.directionsService = new google.maps.DirectionsService(), n;
        }
        return e = a, (r = [{
          key: "_computeDistancesForMode",
          value: function (t, e, n) {
            var r = this,
              o = t.map(function (t) {
                return new google.maps.LatLng(t.lat, t.lng);
              }),
              i = e.map(function (t) {
                return new google.maps.LatLng(t.lat, t.lng);
              });
            return new Promise(function (a, u) {
              r.distanceMatrixService.getDistanceMatrix({
                origins: o,
                destinations: i,
                travelMode: P[n]
              }, function (o, i) {
                "OK" === i ? a(r._parseDistancesMatrixForMode(t, e, n, o)) : u(new Error("Unable to fetch distances from Google: ".concat(i, " ").concat(JSON.stringify(o))));
              });
            });
          }
        }, {
          key: "_parseDistancesMatrixForMode",
          value: function (t, e, r, o) {
            return o.rows.map(function (o, i) {
              return o.elements.map(function (o, a) {
                if ("OK" === o.status) {
                  var u = new f(o.distance.value, n.units.meter),
                    c = new f(o.duration.value, n.units.second);
                  return new l(t[i], e[a], r, [u, c]);
                }
              });
            });
          }
        }, {
          key: "_computeRouteForMode",
          value: function (t, e, r) {
            var o = this;
            return new Promise(function (i, a) {
              o.directionsService.route({
                origin: new google.maps.LatLng(t.lat, t.lng),
                destination: new google.maps.LatLng(e.lat, e.lng),
                travelMode: P[r]
              }, function (o, u) {
                switch (u) {
                  case "OK":
                    var c,
                      s,
                      l = o.routes,
                      p = [];
                    if ((null == l ? void 0 : l.length) > 0) {
                      var y,
                        m = M(l, 1)[0];
                      if ((null === (y = m.legs) || void 0 === y ? void 0 : y.length) > 0) {
                        var h = M(m.legs, 1)[0];
                        h.distance && p.push(new f(h.distance.value, n.units.meter)), h.duration && p.push(new f(h.duration.value, n.units.second));
                      }
                      (s = new d(t, e, r, p)).path = l[0].overview_path.map(function (t) {
                        return {
                          lat: t.lat(),
                          lng: t.lng()
                        };
                      }), s.copyrights = o.routes[0].copyrights, s.warnings = o.warnings;
                    }
                    null !== (c = s) && void 0 !== c && c.path ? i(s) : a("no result found");
                    break;
                  case "ZERO_RESULTS":
                    a("no result returned");
                    break;
                  default:
                    a("Status ".concat(u, " not handled"));
                }
              });
            });
          }
        }]) && S(e.prototype, r), o && S(e, o), a;
      }(b);
    var T,
      L = function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
      };
    function R(t) {
      return (R = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }
    function D(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
        if (null == n) return;
        var r,
          o,
          i = [],
          a = !0,
          u = !1;
        try {
          for (n = n.call(t); !(a = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); a = !0);
        } catch (t) {
          u = !0, o = t;
        } finally {
          try {
            a || null == n.return || n.return();
          } finally {
            if (u) throw o;
          }
        }
        return i;
      }(t, e) || function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return I(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return I(t, e);
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function I(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
      return r;
    }
    function U(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }
    function N(t, e) {
      return (N = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }
    function C(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = G(t);
        if (e) {
          var o = G(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return F(this, n);
      };
    }
    function F(t, e) {
      if (e && ("object" === R(e) || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t);
    }
    function G(t) {
      return (G = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }
    function B(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }
    L.isNullOrEmpty = function (t) {
      return !t || 0 === t.length;
    };
    var J = (B(T = {}, n.modes.driving, "mapbox/driving"), B(T, n.modes.cycling, "mapbox/cycling"), B(T, n.modes.transit, "mapbox/transit"), B(T, n.modes.walking, "mapbox/walking"), T),
      K = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && N(t, e);
        }(a, t);
        var e,
          r,
          o,
          i = C(a);
        function a(t) {
          var e, n;
          if (function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, a), (n = i.call(this)).config = null === (e = t.providers) || void 0 === e ? void 0 : e.mapbox, !n.config || L.isNullOrEmpty(n.config.url) || L.isNullOrEmpty(n.config.key)) throw new Error("Invalid mapbox configuration.");
          return n;
        }
        return e = a, (r = [{
          key: "_computeDistancesForMode",
          value: function (t, e, n) {
            var r = this,
              o = t.map(function (t) {
                return "".concat(t.lng, ",").concat(t.lat);
              }).concat(e.map(function (t) {
                return "".concat(t.lng, ",").concat(t.lat);
              })).join(";"),
              i = Array(t.length).fill().map(function (t, e) {
                return e;
              }).join(";"),
              a = Array(e.length).fill().map(function (e, n) {
                return n + t.length;
              }).join(";"),
              u = "".concat(this.config.url, "/directions-matrix/v1/").concat(J[n], "/").concat(o, "?sources=").concat(i, "&destinations=").concat(a, "&annotations=duration,distance");
            return this._fetch("".concat(u, "&access_token=").concat(this.config.key)).then(function (o) {
              if (o.ok) return o.json().then(function (o) {
                if (o.code && "Ok" === o.code) return r._parseDistancesMatrixForMode(t, e, n, o);
                throw new Error("Unable to fetch distances from Mapbox URL ".concat(u, ": ").concat(JSON.stringify(o)));
              });
              throw new Error("Unable to fetch distances from Mapbox URL ".concat(u, ": ").concat(o.status, " ").concat(o.statusText));
            });
          }
        }, {
          key: "_parseDistancesMatrixForMode",
          value: function (t, e, r, o) {
            return o.distances.map(function (i, a) {
              return i.map(function (i, u) {
                var c = new f(i, n.units.meter),
                  s = new f(o.durations[a][u], n.units.second);
                return new l(t[a], e[u], r, [c, s]);
              });
            });
          }
        }, {
          key: "_computeRouteForMode",
          value: function (t, e, r) {
            var o = "".concat(t.lng, ",").concat(t.lat, ";").concat(e.lng, ",").concat(e.lat),
              i = "overview=".concat(this.config.overview),
              a = "".concat(this.config.url, "/directions/v5/").concat(J[r], "/").concat(o, "?geometries=geojson&").concat(i);
            return this._fetch("".concat(a, "&access_token=").concat(this.config.key)).then(function (o) {
              if (o.ok) return o.json().then(function (o) {
                if ("Ok" === o.code) {
                  var i,
                    u = o.routes,
                    c = u && u.length > 0 ? u[0] : {},
                    s = null === (i = c.geometry) || void 0 === i ? void 0 : i.coordinates,
                    l = [];
                  c.distance && l.push(new f(c.distance, n.units.meter)), c.duration && l.push(new f(c.duration, n.units.second));
                  var p = new d(t, e, r, l);
                  if (!s) throw new Error("No route result found from Mapbox URL ".concat(a, ": ").concat(JSON.stringify(o)));
                  return p.path = s.map(function (t) {
                    var e = D(t, 2),
                      n = e[0];
                    return {
                      lat: e[1],
                      lng: n
                    };
                  }), p;
                }
                throw new Error("Unable to fetch directions from Mapbox URL ".concat(a, ": ").concat(JSON.stringify(o)));
              });
              throw new Error("Unable to fetch directions from Mapbox URL ".concat(a, ": ").concat(o.status, " ").concat(o.statusText));
            });
          }
        }]) && U(e.prototype, r), o && U(e, o), a;
      }(b);
    function z(t) {
      return (z = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }
    function $(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }
    function Y(t, e) {
      return (Y = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }
    function V(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = Z(t);
        if (e) {
          var o = Z(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return W(this, n);
      };
    }
    function W(t, e) {
      if (e && ("object" === z(e) || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t);
    }
    function Z(t) {
      return (Z = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }
    var q = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Y(t, e);
      }(i, t);
      var e,
        n,
        r,
        o = V(i);
      function i(t) {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, i), o.call(this);
      }
      return e = i, (n = [{
        key: "_getDistances",
        value: function (t, e, n) {
          return Promise.reject(new Error("NOT IMPLEMENTED YET."));
        }
      }]) && $(e.prototype, n), r && $(e, r), i;
    }(b);
    var H = function t() {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t);
    };
    function Q(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }
    function X(t) {
      return (X = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }
    H.create = function (t) {
      var e;
      switch (t.provider) {
        case n.providers.google:
          return new A(t);
        case n.providers.mapbox:
          return new K(t);
        case n.providers.eg:
          return new q(t);
        default:
          throw new Error("Invalid provider: ".concat(null === (e = t.provider) || void 0 === e ? void 0 : e.type));
      }
    };
    var tt = function t() {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t);
    };
    function et(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }
    tt.isObject = function (t) {
      return t && "object" === X(t) && !Array.isArray(t);
    }, tt.merge = function (t) {
      for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) n[r - 1] = arguments[r];
      if (!n.length) return t;
      var o = n.shift();
      if (tt.isObject(t) && tt.isObject(o)) for (var i in o) tt.isObject(o[i]) ? (t[i] || Object.assign(t, Q({}, i, {})), tt.merge(t[i], o[i])) : Object.assign(t, Q({}, i, o[i]));
      return tt.merge.apply(tt, [t].concat(n));
    };
    var nt = function () {
      function t(e) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.config = tt.merge({}, r, e || {}), this.provider = H.create(this.config);
      }
      var e, n, o;
      return e = t, (n = [{
        key: "getDistances",
        value: function (t, e, n) {
          return this.provider.getDistances(t, e, n);
        }
      }, {
        key: "getRoute",
        value: function (t, e, n) {
          return this.provider.getRoute(t, e, n);
        }
      }]) && et(e.prototype, n), o && et(e, o), t;
    }();
    return Object.assign(nt, n), e;
  }();
});